import { Auth } from "aws-amplify";
import { addAWSToken, buildApiUrl } from "../helpers";
import tryTill from "../helpers/tryTill";
import { HTTPS_STATUS_CODES } from "./http.constants";
import { GITHUB_AUTH_FLOW } from "../../constants";
import addGithubToken from "../helpers/addGithubToken";

const { BAD_REQUEST, INTERNAL_SERVER_ERROR, NO_CONTENT } = HTTPS_STATUS_CODES;
const { GITHUB, PROVIDER } = GITHUB_AUTH_FLOW;
const INVITED_USERS = "invited-users";
const GITHUB_AUTHENTICATION = "github-authentication";
const INVITATIONS = "invitations"

const logError = (showNoError, { exception, errorMessage } = {}) => {
  const message = errorMessage || exception.message || exception;
  console.log("Error Message:", message);
};

const handleRequestMethod = async (
  url,
  httpMethod,
  config,
  successMessage,
  errorMessage
) => {
  let cognitoUser = null;
  const provider = sessionStorage.getItem(PROVIDER);
  if (
    !url.includes(INVITED_USERS) &&
    !url.includes(GITHUB_AUTHENTICATION) &&
    provider !== GITHUB
  )
    cognitoUser = await Auth.currentAuthenticatedUser().catch((err) =>
      console.log("authentication failed here", err)
    );

  if (!url) throw new Error("You must specify a url");

  const handleFetch = async () => {
    let response;
    let newConfig = {};
    if (!url.includes(INVITED_USERS) && !url.includes(GITHUB_AUTHENTICATION) && !url.includes(INVITATIONS)) {
      if (provider === GITHUB) newConfig = await addGithubToken(config);
      else newConfig = await addAWSToken(cognitoUser, config);
    } else newConfig = { ...newConfig, ...config };

    try {
      const apiUrl = buildApiUrl(url);
      return fetch(apiUrl, { ...newConfig, method: httpMethod }).then(
        (response) => {
          if (response.ok) {
            if (
              response.headers &&
              response.headers.map &&
              response.headers.map["content-type"].includes("stream")
            )
              return response;
            else if (response.status === NO_CONTENT)
              Promise.resolve("No Content");
            return response.json();
          } else if (
            response.status === BAD_REQUEST ||
            response.status === INTERNAL_SERVER_ERROR
          ) {
            return Promise.reject(response);
          }

          Promise.reject(response);
        }
      );
    } catch (exception) {
      logError(false, { exception, errorMessage });
      response = { ...response, status: exception.response.status };
    }

    return response;
  };

  return tryTill(handleFetch, () =>
    cognitoUser ? cognitoUser.signInUserSession.accessToken.jwtToken : true
  );
};

const get = (url, config, { successMessage, errorMessage } = {}) => {
  return handleRequestMethod(url, "GET", config, successMessage, errorMessage);
};

const post = (url, config, { successMessage, errorMessage } = {}) => {
  return handleRequestMethod(url, "POST", config, successMessage, errorMessage);
};

const put = (url, config, { successMessage, errorMessage } = {}) => {
  return handleRequestMethod(url, "PUT", config, successMessage, errorMessage);
};

const patch = (url, config, { successMessage, errorMessage } = {}) => {
  return handleRequestMethod(
    url,
    "PATCH",
    config,
    successMessage,
    errorMessage
  );
};

const invokeDelete = (url, config, { successMessage, errorMessage } = {}) => {
  return handleRequestMethod(
    url,
    "DELETE",
    config,
    successMessage,
    errorMessage
  );
};

const httpMethods = {
  GET: get,
  POST: post,
  PUT: put,
  PATCH: patch,
  DELETE: invokeDelete,
};

export default httpMethods;
